export const LinksData = [
  {
    title: 'Home',
    linkTo: '/',
  },
  {
    title: 'Skills',
    linkTo: '/skills',
  },
  {
    title: 'Experience',
    linkTo: '/experience',
  },
  {
    title: 'Projects',
    linkTo: '/projects',
  },
  {
    title: 'Contact',
    linkTo: '/contact',
  },
];
